import { useEffect, useState } from "react";

// Cycles through words in place, like the reference site's hero.
export const WordRotator = ({ words, interval = 1600, className = "" }) => {
  const [i, setI] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setI((n) => (n + 1) % words.length), interval);
    return () => clearInterval(id);
  }, [words.length, interval]);

  // Reserve the width of the longest word so the pill behind it never jumps.
  const widest = words.reduce((a, b) => (b.length > a.length ? b : a), "");

  return (
    <span
      className={`relative block h-[1.12em] ${className}`}
      data-testid="hero-word-rotator"
    >
      <span aria-hidden="true" className="invisible block">
        {widest}
      </span>
      <span className="sr-only">{words.join(", ")}</span>
      {words.map((w, n) => (
        <span
          key={w}
          aria-hidden="true"
          className={`absolute inset-x-0 top-0 transition-[opacity,transform] duration-200 ${
            n === i ? "opacity-100 translate-y-0" : "pointer-events-none -translate-y-2 opacity-0"
          }`}
        >
          {w}
        </span>
      ))}
    </span>
  );
};

export default WordRotator;
